import React, { memo } from 'react';

// styles
import { MessageContainer, Text } from './styles';
interface IMessageProp {
  message: string;
  onHide: VoidFunction;
}

function Message({ message, onHide }: IMessageProp) {
  return (
    <MessageContainer onAnimationEnd={onHide}>
      <Text>{message}</Text>
    </MessageContainer>
  );
}

export default memo(Message);
